import {
  type CheckoutSession,
  CheckoutStatus,
  Currency,
  PaymentResultStatus,
} from "@/types";

export const emptySession: CheckoutSession = {
  id: "",
  orderId: "",
  orderTotalAmount: {
    amount: 0,
    currency: "",
  },
  paymentType: "PAY_BY_INSTALMENTS",
  status: CheckoutStatus.UNKNOWN,
  merchant: {
    id: "",
    name: "",
    arName: "",
    platform: "",
    logoUrl: "",
    urls: {
      success: "",
      failure: "",
      cancel: "",
    },
  },
  order: {
    id: "",
    items: [],
    currency: Currency.SAR,
    countryCode: "",
  },
  customerId: "",
  paymentOptions: [],
  isOfferPreSelected: false,
  shouldUsePaymentWidget: false,
  locale: "",
  installments: null,
  documents: [],
  paymentMethod: null,
  ivrStatus: "",
  triggeredIvrAt: null,
  ivrTimeout: 0,
  selectedPaymentOptionId: "",
  paymentResult: {
    redirectUrl: "",
    status: PaymentResultStatus.UNKNOWN,
  },
  shouldShowIvr: false,
  shouldShowDocumentSigning: false,
  declinedOffers: [],
  redirectUrl: "",
  creditDeclineInfo: null,
  country: {
    applePayAllowed: false,
    cardsAllowed: [],
    ckoPublicKey: "",
    ckoPublicKeyV2: "",
    currency: Currency.SAR,
    isoCode2: "",
    isoCode3: "",
  },
};
